import { Component, inject, input, linkedSignal, signal, viewChild } from '@angular/core';
import { Notification, Button, NotificationService } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  imports: [Notification, Button, NgIcon, TranslocoPipe],
  templateUrl: './energy-interface-details-edit-success-notification.html',
})
export class EnergyInterfaceDetailsEditSuccessNotification {
  private notificationService = inject(NotificationService);
  private translocoService = inject(TranslocoService);

  notification = viewChild(Notification);
  uuid = input.required<string>();
  duration = input.required<number>();

  clickUndoCallback = input.required<() => Promise<void>>();

  customDuration = linkedSignal(this.duration);

  loading = signal(false);

  async onClickUndo() {
    this.loading.set(true);
    this.notificationService.stopDismissTimeout(this.uuid());
    this.customDuration.set(0);
    try {
      const undoCallback = this.clickUndoCallback();
      await undoCallback();
      this.notificationService.showSuccess({
        title: this.translocoService.translate(
          'cockpit.energyInterfaces.details.notifications.editSuccess.undoSuccess',
        ),
      });
    } catch (e) {
      console.error('Undo failed', e);
      this.notificationService.showError({
        title: this.translocoService.translate(
          'cockpit.energyInterfaces.details.notifications.editSuccess.undoError',
        ),
      });
    } finally {
      this.notificationService.dismiss(this.uuid());
    }
  }
}
